
import { ContentLoader } from 'vue-content-loader'

export default {
  components: {
    ContentLoader,
  },
  props: {
    base: {
      type: Number,
      default: 1,
    },
    view: {
      type: String,
      default: 'card',
    },
  },
}
